import React from 'react';
import { Text } from '~/components';

export interface RightTextProps {
  children: string | React.ReactNode;
}

const RightText: React.FC<RightTextProps> = ({ children }) => {
  return (
    <Text
      className="text-gray-400 text-base flex-1 text-right"
      numberOfLines={1}
    >
      {children}
    </Text>
  );
};

export default RightText;
